import React, { Fragment, useState, useEffect } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';
import { postData, fetchData } from '../../../apiService';
import Select from 'react-select'; // Import react-select
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';

const SalaryAdvanceCreate = ({ match }) => {
    const [isLoading, setIsLoading] = useState(false);
    const history = useHistory();
    const { id } = useParams();
    const { isAuthenticated, companyId, branchId, userId, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [recordCount, setRecordCount] = useState(0);
    const [customerOptions, setCustomerOptions] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [invoicedeatils, setInvoicedeatils] = useState([]);

    const [formData, setFormData] = useState({
        CompanyId: companyId,
        CreatedBy: userId,
        isSubmit: false,
        AdvanceAmount: 0,
        SplitAmount: 0,
        RepaymentDays: 0,
    });

    // Handle customer selection
    const handleCustomerSelect = (selectedOption) => {
        setSelectedCustomer(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            EmployeeId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

    };

    useEffect(() => {
        fetchCustomerData();
    }, []);

    //FOR GET Customer  Details FROM API
    const fetchCustomerData = () => {
        fetchData('EmployeeApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                // Transform the data into the format that react-select expects (label and value)                
                const options = data.map((customer) => ({
                    label: customer.EmployeeCode + '-' + customer.EmployeeName,
                    value: customer.Id,
                }));
                setCustomerOptions(options);
            })
            .catch((error) => {
                console.error('Error fetching customer data:', error);
            });
    };

    const [isFullScreen, setIsFullScreen] = useState(false);
    useEffect(() => {
        function handleResize() {
            setIsFullScreen(window.innerWidth >= 768); // Assuming full screen width is 768px or larger, adjust as needed
        }
        window.addEventListener('resize', handleResize);
        handleResize(); // Initial check
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData((prev) => {
            const updated = { ...prev, [name]: value };

            // ✅ Format date safely (local time, not UTC)
            const fmt = (d) => {
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const day = String(d.getDate()).padStart(2, "0");
                return `${year}-${month}-${day}`;
            };

            const toDate = (v) => (v ? new Date(v) : null);

            // Base AdvanceDate (fallback to today)
            const advDate = toDate(updated.AdvanceDate) || new Date();

            // Always normalize start date to 1st of AdvanceDate's month
            const startDate = new Date(advDate.getFullYear(), advDate.getMonth(), 1);
            updated.RepaymentStartDate = fmt(startDate);

            // Update RepaymentEndDate based on RepaymentDays if provided
            if (name === "RepaymentDays") {
                const months = parseInt(value, 10);
                if (!isNaN(months) && months > 0) {
                    // End date = last day of the month after adding `months`
                    const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + months, 0);
                    updated.RepaymentEndDate = fmt(endDate);
                } else {
                    updated.RepaymentEndDate = "";
                }
            }

            // If AdvanceDate changes manually, set default 1-month end date
            if (name === "AdvanceDate" && !updated.RepaymentDays) {
                const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
                updated.RepaymentEndDate = fmt(endDate);
            }

            // ✅ Calculate SplitAmount = Amount / RepaymentDays (if both are valid)
            const amount = parseFloat(updated.AdvanceAmount);
            const days = parseInt(updated.RepaymentDays, 10);

            if (!isNaN(amount) && !isNaN(days) && days > 0) {
                updated.SplitAmount = (amount / days).toFixed(2); // round to 2 decimals
            } else {
                updated.SplitAmount = "";
            }

            return updated;
        });
    };

    // Add a function to format the date
    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        return formattedDate;
    };

    // FOR Current Date and Time
    useEffect(() => {
        const currentDate = new Date();
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;
        const endDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
        const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

        setFormData((prevData) => ({
            ...prevData,
            CompanyId: companyId,
            AdvanceDate: formattedDate,
            RepaymentStartDate: startDate,
            RepaymentEndDate: endDate,
            RepaymentDays: 1,
            CreatedBy: userId,
        }));
    }, []);

    const submitData = async (e) => {
        setIsLoading(true);

        if (!formData.EmployeeId || formData.EmployeeId === 0) {
            setErrorMessage('Employee is required!');
            setIsLoading(false);
            return;
        }

        if (!formData.AdvanceAmount || formData.AdvanceAmount === 0) {
            setErrorMessage('Amount must be Greater than 0!');
            setIsLoading(false);
            return;
        }

        try {
            const response = await postData('SalaryAdvanceApi', formData, token);
            setSuccessMessage('SalaryAdvance Created successfully!');
            setErrorMessage('');

            history.push('/SalaryAdvanceIndex');
            setTimeout(() => {
                setSuccessMessage("");
            }, 3000);

        } catch (error) {
            console.error('Receipt Create error:', error);
            if (error.response) {
                console.error('Response data:', error.response.data);
                console.error('Response status:', error.response.status);
                console.error('Response headers:', error.response.headers);
            } else if (error.request) {
                console.error('Request was made but no response received:', error.request);
            } else {
                console.error('Error in setting up the request:', error.message);
            }
            setErrorMessage('Failed to create receipt. Please try again.');
            setIsLoading(false);
        }
    };

    return (
        <div className="w-full container mx-auto mt-1" style={{ maxWidth: "100%" }}>
            {/* Header Section */}
            <div className="flex justify-between items-center bg-white rounded-xl shadow-sm border border-gray-200 px-2 py-2 mb-5">
                <h6
                    className="uppercase tracking-wide font-serif text-black mt-2 text-gray-700 flex-grow"
                    style={{ fontSize: "14px", fontWeight: "500" }}
                >
                    Salary Advance Create
                </h6>

                <div className="flex items-center space-x-2">
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={submitData}
                        disabled={isLoading}
                        style={{ height: "25px", borderRadius: "10px" }}
                    >
                        {isLoading ? <CircularProgress size={22} color="inherit" /> : "Save"}
                    </Button>

                    {/* Back to List Button */}
                    <Button
                        variant="contained"
                        color="error"
                        component={Link}
                        to={{
                            pathname: "/SalaryAdvanceIndex",
                            state: { from: "/SalaryAdvanceCreate" },
                        }}
                        onClick={() => {
                            localStorage.setItem("shouldReload", "true");
                        }}
                        style={{ height: "25px", borderRadius: "10px", marginRight: "5px", marginLeft: "5px" }}
                    >
                        Back To List
                    </Button>

                </div>
            </div>

            {errorMessage && (
                <p className="text-red-600 text-sm mb-4 text-center font-medium">
                    {errorMessage}
                </p>
            )}

            {/* Form Card */}
            <div className="bg-white rounded-xl shadow-md border border-gray-200 p-2" style={{ marginTop: '-30px' }}>
                {/* Row 1 */}
                <div className="grid grid-cols-6 gap-1 mb-3">
                    <div className="col-span-2">
                        <label className="text-xs uppercase mb-1 block">
                            Employee Name <span className="text-red-500">*</span>
                        </label>
                        <Select
                            value={selectedCustomer}
                            onChange={handleCustomerSelect}
                            options={customerOptions}
                            placeholder="Select Employee"
                            isSearchable
                            styles={{
                                control: (base) => ({
                                    ...base,
                                    minHeight: '33px',
                                    height: '33px',
                                    borderRadius: 8,
                                    borderColor: '#d1d5db',
                                    fontSize: 14,
                                }),
                                valueContainer: (base) => ({
                                    ...base,
                                    height: '33px',
                                    padding: '0 8px',
                                }),
                                input: (base) => ({
                                    ...base,
                                    margin: 0,
                                    padding: 0,
                                }),
                                singleValue: (base) => ({
                                    ...base,
                                    fontSize: 14,
                                }),
                                indicatorsContainer: (base) => ({
                                    ...base,
                                    height: '33px',
                                }),
                            }}
                        />
                    </div>

                    <div>
                        <label className="text-xs uppercase mb-1 block">Advance Date <span className="text-red-500">*</span></label>
                        <input
                            type="date"
                            name="AdvanceDate"
                            value={formatDateForInput(formData.AdvanceDate)}
                            onChange={handleChange}
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            style={{ height: '33px' }}
                        />
                    </div>

                    <div>
                        <label className="text-xs uppercase mb-1 block">
                            Repayment Months <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="number"
                            name="RepaymentDays"
                            value={formData.RepaymentDays || ""}
                            onChange={handleChange}
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm bg-gray-50"
                            style={{ height: '33px', textAlign: 'right' }}
                        />
                    </div>

                    <div>
                        <label className="text-xs uppercase mb-1 block">
                            Repayment Start Date
                        </label>
                        <input
                            type="date"
                            name="RepaymentStartDate"
                            value={formatDateForInput(formData.RepaymentStartDate)}
                            onChange={handleChange}
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            style={{ height: '33px' }}
                        />
                    </div>

                    <div>
                        <label className="text-xs uppercase mb-1 block">
                            Repayment End Date
                        </label>
                        <input
                            type="date"
                            name="RepaymentEndDate"
                            value={formatDateForInput(formData.RepaymentEndDate)}
                            onChange={handleChange}
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            style={{ height: '33px' }}
                        />
                    </div>
                </div>

                {/* Row 2 */}
                <div className="grid grid-cols-7 gap-2">
                    {/* Remarks - wider */}
                    <div className="col-span-5">
                        <label className="text-xs uppercase mb-1 block">Remarks</label>
                        <input
                            type="text"
                            name="Remarks"
                            value={formData.Remarks}
                            onChange={handleChange}
                            placeholder="Remarks"
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            style={{ height: '33px' }}
                        />
                    </div>

                    {/* Amount - smaller */}
                    <div className="col-span-1">
                        <label className="text-xs uppercase mb-1 block">
                            Amount <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="number"
                            name="AdvanceAmount"
                            value={formData.AdvanceAmount || "0"}
                            onChange={handleChange}
                            placeholder="AdvanceAmount"
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm text-right font-semibold focus:ring-2 focus:ring-blue-500 focus:outline-none"
                            style={{ height: '33px' }}
                        />
                    </div>

                    {/* Split Amount - smaller */}
                    <div className="col-span-1">
                        <label className="text-xs uppercase mb-1 block">
                            Split Amount <span className="text-red-500">*</span>
                        </label>
                        <input
                            type="number"
                            name="SplitAmount"
                            value={formData.SplitAmount || "0"}
                            onChange={handleChange}
                            placeholder="Split Amount"
                            readOnly
                            className="border border-gray-300 rounded-lg px-3 py-2 w-full text-sm text-right font-semibold bg-gray-50"
                            style={{ height: '33px' }}
                        />
                    </div>
                </div>

            </div>
        </div>
    );


}

export default SalaryAdvanceCreate;
